// @flow

import { postApi } from './api.core'

export const add = params => postApi('api/address/', params)
export const update = (_, params) => postApi('api/address/', params) // change to post to patch
